var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppInDesignServer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#49021F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0605 37.9629C39.5069 38.7399 36.4358 39.5536 33.1055 39.5537C27.4072 39.5537 22.4482 36.3342 22.4482 29.6738C22.4484 22.9394 27.4806 19.5723 32.6982 19.5723C33.4014 19.5723 34.1411 19.6465 34.585 19.7207V13.6523H41.0605V37.9629ZM19.8223 39.2207H12.9395V14.4297H19.8223V39.2207ZM32.8457 24.8271C30.8105 24.8271 28.9238 26.0112 28.9238 29.5635C28.924 32.8196 30.6261 34.2998 32.8828 34.2998C33.4014 34.2998 34.104 34.2624 34.585 34.1514V25.0859C34.1411 24.938 33.5859 24.8271 32.8457 24.8271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppInDesignServer);
export default __webpack_public_path__ + "static/media/B_app_InDesignServer.49e7dfa0f9ef3167f1f51f1362d5d768.svg";
export { ForwardRef as ReactComponent };